// import React from 'react';
// import { Box, Typography, IconButton, Button } from '@mui/material';
// import CloseIcon from '@mui/icons-material/Close';
// import DoneIcon from '@mui/icons-material/Done';
// import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

// interface SnackbarModalProps {
// 	open?: boolean;
// 	action?: 'approve' | 'reject' | null;
// 	onClose?: () => void;
// 	Message: string;
// 	loading?: boolean;
// }

// export default function MySnackbarModal({
// 	open,
// 	action,
// 	onClose,
// 	Message,
// 	loading = false,
// }: SnackbarModalProps) {
// 	if (!open) return null;

// 	const isApprove = action === 'approve';

// 	return (
// 		<Box
// 			sx={{
// 				position: 'fixed',
// 				inset: 0,
// 				backgroundColor: 'rgba(0,0,0,0.3)',
// 				display: 'flex',
// 				alignItems: 'center',
// 				justifyContent: 'center',
// 				zIndex: 1300,
// 			}}
// 		>
// 			<Box
// 				sx={{
// 					position: 'relative',
// 					width: 491,
// 					bgcolor: 'white',
// 					borderRadius: '20px',
// 					boxShadow: '0px 4px 4px rgba(0,0,0,0.1)',
// 					fontFamily: "'Poppins', sans-serif",
// 					p: 3,
// 					textAlign: 'center',
// 				}}
// 			>
// 				{/* Close Button */}
// 				<IconButton
// 					onClick={onClose}
// 					size="small"
// 					sx={{ position: 'absolute', top: 20, right: 20 }}
// 					aria-label="close"
// 					disabled={loading}
// 				>
// 					<CloseIcon />
// 				</IconButton>

// 				{/* Circle with icon */}
// 				<Box
// 					sx={{
// 						width: 96,
// 						height: 96,
// 						m: 'auto',
// 						borderRadius: '50%',
// 						background: isApprove
// 							? 'linear-gradient(to bottom right, #86efac, #047857)'
// 							: 'linear-gradient(to bottom right, #fca5a5, #b91c1c)',
// 						display: 'flex',
// 						alignItems: 'center',
// 						justifyContent: 'center',
// 						mb: 2,
// 					}}
// 				>
// 					{isApprove ? (
// 						<DoneIcon sx={{ fontSize: 50, color: 'white' }} />
// 					) : (
// 						<CloseRoundedIcon sx={{ fontSize: 50, color: 'white' }} />
// 					)}
// 				</Box>

// 				{/* Title */}
// 				<Typography
// 					variant="h5"
// 					sx={{
// 						color: isApprove ? '#166534' : '#b91c1c',
// 						fontWeight: 600,
// 						fontSize: '2rem',
// 						lineHeight: 1,
// 						userSelect: 'none',
// 						mb: 2,
// 					}}
// 				>
// 					{isApprove ? 'Success' : 'Error'}
// 				</Typography>

// 				{/* Message */}
// 				<Typography
// 					sx={{
// 						color: '#000000',
// 						fontSize: '1rem',
// 						lineHeight: 1.3,
// 						userSelect: 'none',
// 						mb: 4,
// 					}}
// 				>
// 					{Message}
// 				</Typography>

// 				{/* OK Button */}
// 				<Button
// 					variant="contained"
// 					color={isApprove ? 'success' : 'error'}
// 					onClick={onClose}
// 					disabled={loading}
// 					sx={{ minWidth: 120 }}
// 				>
// 					OK
// 				</Button>
// 			</Box>
// 		</Box>
// 	);
// }

import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

interface SnackbarModalProps {
	open?: boolean;
	action?: 'approve' | 'reject' | null;
	onClose?: () => void;
	Message: string;
	loading?: boolean;
}

export default function MySnackbarModal({
	open,
	action,
	onClose,
	Message,
	loading = false,
}: SnackbarModalProps) {
	console.log(loading);
	useEffect(() => {
		if (open) {
			const timer = setTimeout(() => {
				onClose && onClose();
			}, 2000); // 2 seconds

			return () => clearTimeout(timer);
		}
	}, [open, onClose]);

	if (!open) return null;

	const isApprove = action === 'approve';

	return (
		<Box
			sx={{
				position: 'fixed',
				inset: 0,
				backgroundColor: 'rgba(0,0,0,0.3)',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				zIndex: 1300,
				pointerEvents: 'none', // to avoid blocking clicks
			}}
		>
			<Box
				sx={{
					width: 380,
					bgcolor: 'white',
					borderRadius: '12px',
					boxShadow: '0px 4px 12px rgba(0,0,0,0.15)',
					fontFamily: "'Poppins', sans-serif",
					p: 3,
					textAlign: 'center',
					pointerEvents: 'auto', // allow interactions inside box if needed
					userSelect: 'none',
				}}
			>
				{/* Circle with icon */}
				<Box
					sx={{
						width: 72,
						height: 72,
						m: 'auto',
						borderRadius: '50%',
						background: isApprove
							? 'linear-gradient(to bottom right, #86efac, #047857)'
							: 'linear-gradient(to bottom right, #fca5a5, #b91c1c)',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						mb: 1.5,
					}}
				>
					{isApprove ? (
						<DoneIcon sx={{ fontSize: 40, color: 'white' }} />
					) : (
						<CloseRoundedIcon sx={{ fontSize: 40, color: 'white' }} />
					)}
				</Box>

				{/* Title */}
				<Typography
					variant="h6"
					sx={{
						color: isApprove ? '#166534' : '#b91c1c',
						fontWeight: 600,
						mb: 0.8,
					}}
				>
					{isApprove ? 'Success' : 'Error'}
				</Typography>

				{/* Message */}
				<Typography
					sx={{
						color: '#000',
						fontSize: '1rem',
						lineHeight: 1.3,
					}}
				>
					{Message}
				</Typography>
			</Box>
		</Box>
	);
}
